var currentReCaptchaElement=null;

function onSubmitReCaptcha(token) {
    console.debug('recaptcha success!');
    currentReCaptchaElement.attr("captcha_id", null);
    currentReCaptchaElement.trigger("submit");
    currentReCaptchaElement=null;

    return true;
}

function validateReCaptcha(event) {
    var form = $(event.target);

    if(!form.attr("captcha_id"))
        return true;

    currentReCaptchaElement = form;
    event.preventDefault();
    grecaptcha.execute(form.attr("captcha_id"));
}

function initReCaptchaForm(container) {
    //console.log(container.prop("id"));
    //console.log(container.attr("sitekey"));

    var captchaId = grecaptcha.render(container.prop("id"),{
        "sitekey": container.attr("sitekey"),
        "callback": "onSubmitReCaptcha",
        "size":"invisible",
        "badge": "bottomleft"
    });

    var form = container.closest("form");
    form.attr("captcha_id", captchaId);
    form.on("submit", validateReCaptcha);

    if(form.is(".formWaitRecaptcha")){
        $(".waiter", form).animate({
            opacity: 0.0,
        }, 500, function(){
            $(".waiter", form).remove();
        });
    }
}

function initReCaptcha(){
    $(".recaptcha", "body").each(function(i,e){
        initReCaptchaForm($(e));
    });
}
